import React from 'react'
import styles from './index.module.css'
import Container from '../container'
import Link from 'next/link'

const ShutdownBanner = () => {
  return (
    <div className={styles.banner}>
      <Container classNames={styles.container}>
        <div className={styles.content}>
          <svg
            className={styles.icon}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
            />
          </svg>
          <div className={styles.text}>
            <strong>Mnemonic Recovery:</strong> Export your keys and continue using them anywhere.
            <Link href="/auth/login">
              <a className={styles.link}> Log in to export.</a>
            </Link>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default ShutdownBanner

